import { Component, defineComponent, onMounted, onUnmounted } from 'vue';

import SortContainer from '../sort/sort-container/SortContainer.vue';
import FilterContainer from '../filters/filter-container/FilterContainer.vue';
import SearchBar from './SearchBar.class';
import Sort from '../sort/Sort.vue';

export default defineComponent({
	components: {
		FilterContainer: FilterContainer as Component,
		Sort: Sort as Component,
		SortContainer: SortContainer as Component,
	},
	setup: () => {
		const component = new SearchBar();

		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmounted.bind(component));

		return {
			totalSearchResults: component.totalSearchResults,
			resultsLabel: component.resultsLabel,
			currentPageNumber: component.currentPageNumber,
			filterHintCount: component.filterHintCount,
			shouldShowFilters: component.shouldShowFilters,
			modalContent: component.modalContent,
			modalShowContent: component.modalShowContent,
			isApplicationStatusNotReady: component.isApplicationStatusNotReady,
			showFiltersInModal: component.showFiltersInModal.bind(component),
			showSortInModal: component.showSortInModal.bind(component),
			closeModal: component.closeModal.bind(component),
			openModal: component.openModal.bind(component),
			filtersBarMobile: component.filtersBarMobile,
			floatingFiltersButtonMobileWrapper: component.floatingFiltersButtonMobileWrapper,
		};
	},
});
